<template>
  <div>
    <!-- <VueDragResize :x="positionX" class="gis-info" :w="400" :h="infoheight">
            <div class="title">
                <b-row align-h="between">
                    <b-col md="10">
                        <h6 class="mb-0">作物預警</h6>
                    </b-col>
                    <b-col md="auto" class="pointer">
                        <b-button class="close-button" @click="closeWindow()" variant="outline-success">
                            <b-icon icon="x-circle" scale=".8" variant="white"></b-icon>
                        </b-button>
                    </b-col>
                </b-row>
            </div> -->
    <div
      @mousedown="onSelectElement($event)"
      @touchstart="onSelectElement($event)"
    >
      <div>
        <b-col align-h="between">
          <b-row align-h="between">
            <b-col cols="4">
              <h6 class="mb-0">水稻</h6>
            </b-col>
            <b-col cols="auto">
              <h6 class="mb-0">預警/警戒日期: {{ PDobject.date }}</h6>
            </b-col>
          </b-row>
          <b-row style="height: 5vh"></b-row>
          <b-row>
            <p>田間已有穗稻熱病發生，呼籲農友加強巡田與防治。</p>
          </b-row>
          <b-row>
            <p>
              一、(預警條件)<br />1.現況調查病徵1級(穗病斑面積&lt;5%)<br />2.現況調查病徵2級(穗病斑面積5%~20%)<br />二、(警戒條件)現況調查病徵3級以上(穗病斑面積20%以上)
              。
            </p>
          </b-row>
        </b-col>
      </div>
    </div>
    <div>
      <b-tabs content-class="hidescroll" fill>
        <b-tab
          style="overflow-y: inherit;"
          title-link-class="navgationhearder"
          title="預警資訊"
          active
        >
          <b-row>
            <b-col
              ><p>
                稻熱病菌會對葉及稻穗進行為危害，初期葉片上會出現紅褐色或暗綠色病斑，隨病勢進展，病斑呈現紡錘狀且病斑周圍為黃色，中間為灰褐色。稻熱病好發於連續高濕度的環境，當氣溫劇烈變化時，更為加重，尤其在高氮肥、密植而通風不良的稻田更容易發生。<b-link
                  href="https://agriculture.cyhg.gov.tw/News6.aspx?n=71EBB16ADE11EE31&sms=42B53318939B7DBF"
                  >點我查看嘉義縣政府農業處最新資訊！</b-link
                >
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6"
              ><b-img :src="diease1img" fluid alt="Responsive image"></b-img
            ></b-col>
            <b-col cols="6"
              ><b-img :src="diease2img" fluid alt="Responsive image"></b-img
            ></b-col>
          </b-row>
        </b-tab>
        <b-tab title-link-class="navgationhearder" title="防治建議">
          <p>
            農友可先在秧砧上觀察是否有紅褐色病斑，若有大約7-10天本田即有可能發病，在發現病斑應即時進行防治工作，移除秧砧，避免田間感染擴散，並且減少過度施用氮肥避免植株過度徒長，葉壁變薄，降低對此病害的抗性。水稻稻熱病的推薦防治藥劑可於植物保護資訊系統(https://otserv2.tactri.gov.tw/PPM/)、台南區農業改良場水稻病害防治用藥查詢，並遵照其稀釋倍數及安全採收期之規範。
          </p>
        </b-tab>
        <b-tab title-link-class="navgationhearder" title="農情調查">
          <template v-if="PDobject.detial.title == null">
            <h5>請點選地圖</h5>
          </template>
          <template v-else>
            <span>{{ PDobject.detial.title }}</span>
            <hr />
            <h4>{{ PDobject.detial.place }}</h4>
            <div style="height: 2vh"></div>
            <b-table
              style="text-align-last:left;"
              stacked
              striped
              :field="fields"
              :items="PDobject.detial.items"
            ></b-table>
          </template>
        </b-tab>
      </b-tabs>
    </div>
    <!-- </VueDragResize> -->
  </div>
</template>

<script>
// import VueDragResize from 'vue-drag-resize';

export default {
  name: "DragInformationBox3",
  data() {
    return {
      // <summary>
      //  變數宣告
      // </summary>
      items: [
        {
          收穫面積: "80.65公頃",
          種植面積: "80.65公頃",
          每公頃收穫量: "10,000.00公斤",
          收量: "806,500.00",
        },
      ],
      positionX: 0,
      data1:
        "\r\r臺東地區鳳梨釋迦正值營養生長至開花期（夏季修剪期），經行政院農業委員會臺東區農業改良場（以下簡稱臺東場）監測發現卑南鄉鳳梨釋迦果園內有粉介殼蟲正處於若蟲期，且密度有上升之趨勢，臺東場籲請農友加強巡視果園，注意粉介殼蟲發生現況，於發生初期採行防治措施以降低害蟲密度，減少損失。臺東場指出，粉介殼蟲在鳳梨釋迦強剪後多藏匿於樹幹縫隙或樹幹基部，於萌芽後移動至枝條、嫩梢取食繁殖，並逐步擴散至其他部位。結果期則移至果柄、果蒂，甚至果實上取食為害。此外，其分泌之蜜露會吸引螞蟻取食，並誘發煤煙病影響果實外觀，降低商品價值，亦為影響果品外銷的重要因子。",
      data2:
        "\r\r為避免粉介殼蟲為害，臺東場建議下列防治措施供農友參考： \r\r1.加強果園樹體通風，以利於藥劑均勻噴施，同時減少粉介殼蟲棲息環境。 \r\r2.粉介殼蟲寄主範圍廣，清除果園中闊葉雜草等其他寄主，可以減少孳生源。 \r\r3.目前為粉介殼蟲發生初期，田間以1、2齡若蟲為主，多分布於枝幹縫隙與幼嫩枝條，建議下列具系統性之藥劑任選一種進行施用，7天1次連續2次。 \r\r(1)作用機制4A：20%亞滅培水溶性粉劑2,500倍、16 %可尼丁水溶性粒劑1,500倍、20 %達特南水溶性粒劑2,000倍。 \r\r(2)作用機制4C：21.8%速殺氟水懸劑2,200倍或50%速殺氟水分散性粒劑5,000倍。 \r\r(3)作用機制23：100g/L(10%W/V)賜派滅水懸劑1,500倍或150g/L(15%W/V)水分散性油懸劑2,500倍。 \r\r(4)作用機制3A+4A：24.7%(W/V)賽速洛寧水懸混劑4,000倍。將上述藥液以噴霧器作全園噴施，並注意避免在上午11時至下午3時期間噴藥，以免高溫造成藥害。此外，嫩芽對藥劑較敏感，應嚴格遵守用藥規定，依稀釋倍數正確使用。其他防治藥劑及方法，請參考防檢局農藥資訊服務網(https://pesticide.baphiq.gov.tw/)或植物保護資訊系統(https://otserv2.tactri.gov.tw/PPM/)，若有防治上的問題請洽臺東場植物保護研究室(089-325015)或洽各區病蟲害診斷服務站(0800-069-880)。",
      datetime: [],
      mergetime: "",
      codition: "",
      showdetail: true,
      alertinformation: "",
      title: "",
      message: "",
      diease1img: require("../assets/diease1.png"),
      diease2img: require("../assets/diease2.png"),
      disasterTile: [
        "",
        "颱風警戒",
        "焚風警戒",
        "降水警戒",
        "高溫警戒",
        "寒害警戒",
        "注意霪雨",
        "注意高溫",
        "注意寒害",
        "注意回溫",
        "注意降溫",
      ],
      fields: [
        {
          key: "ObsTime",
          label: "日期",
        },
        {
          key: "TEMP",
          label: "平均溫度",
        },
        {
          key: "H_24R",
          label: "雨量",
        },
        {
          key: "HUMD",
          label: "相對溼度",
        },
      ],
      yearSelected: "",
      periodSelected: "",
      resize: true,
      // infoheight: 600
    };
  },
  props:
    // ['infoheight','ifPDWindowShow', 'PDobject'],
    {
      infoheight: Number,
      ifPDWindowShow_ear: Boolean,
      isFoodItemSelected: Boolean,
      cropInfoShow: Boolean,
      PDobject: null,
    },
  // props: ['selected','cropInfo','cropInfoShow','isFoodItemSelected','yearList', 'yearPeroidList', 'AREA_P', 'warningTownName', 'warningValueList', 'historyLists'],
  // props: ['selected','isFoodItemSelected','yearList', 'yearPeroidList', 'AREA_P', 'warningTownName', 'warningValueList', 'historyLists'],
  // created()
  // {

  // },
  // components: {
  //     VueDragResize
  // },
  watch: {
    ifPDWindowShow_ear(value) {
      if (value) {
        this.init();
      }
    },
  },
  mounted() {
    // this.checkPermission()
    // this.checkMomth();
  },
  methods: {
    init() {
      if (this.isFoodItemSelected && this.cropInfoShow) {
        this.positionX = 800;
      } else if (this.isFoodItemSelected || this.cropInfoShow) {
        this.positionX = 400;
      } else {
        this.positionX = 0;
      }
    },
    changeWhiteSpace(item) {
      return this.IsNull(item) == "" ? "" : item.replaceAll("\r\r", "<br>");
    },
    /* <summary>
            解決視窗拖移後無法點擊控制項的問題
            </summary>*/
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000003", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        this.showdetail = false;
      } else {
        this.showdetail = true;
      }
    },
    onSelectElement(event) {
      const tagName = event.target.tagName;
      if (tagName === "SELECT" || tagName === "LI") {
        event.stopPropagation();
      }
    },
    // changeActive()
    // {
    //     this.resize = !this.resize
    // },
    // /*       <summary>
    //           關閉歷年作物查詢的視窗
    //          </summary>*/
    //         closeCropInfo(){
    //             this.$parent.closeCropInfo();
    //         },

    parseDate(date) {
      return date.split("T")[0];
    },
    parseHumd(data) {
      let num = parseFloat(data) * 100;
      return Math.round(num) + "%";
    },
    paseTemp(data) {
      return Math.round(data);
    },
    /*       <summary>
            時間顯示正規化
        </summary>*/
    dateFormatParse(data) {
      var parsedate = data.split("T");
      var date = parsedate[0].replace(/-/gi, "/");
      var slittime = parsedate[1].substr(0, 2);
      var afterorbeforenoon = slittime;
      if (parseInt(afterorbeforenoon) > 12) {
        afterorbeforenoon = "下午";
      } else {
        afterorbeforenoon = "上午";
      }
      this.mergetime = date + " " + afterorbeforenoon + " " + parsedate[1];
    },
    /*       <summary>
            時間顯示正規化
        </summary>*/
    timeFormatParse(data) {
      var parsedate = data.split("T");
      var date = parsedate[0].replace(/-/gi, "/");
      var slittime = parsedate[1].substr(0, 2);
      var afterorbeforenoon = slittime;
      if (parseInt(afterorbeforenoon) > 12) {
        afterorbeforenoon = "下午";
      } else {
        afterorbeforenoon = "上午";
      }
      var time = date + " " + afterorbeforenoon + " " + parsedate[1];
      return time;
    },
    /*       <summary>
            關閉視窗
        </summary>*/
    closeWindow() {
      this.$parent.closePDWindow();
    },
    /*       <summary>
          更改"警戒"與"注意"的標題
         </summary>*/
    changeTitle(disaster) {
      switch (disaster) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          this.title = "警戒";
          break;
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          this.title = "注意";
          break;
      }
    },
    /*       <summary>
          取得農作物在該城市的範圍
         </summary>*/
    getCityArea() {
      this.$parent.regetCityArea(this.yearSelected, this.periodSelected);
    },
    checkMomth() {
      var d = new Date();
      var nowMonth = d.getMonth() + 1;
      if (nowMonth == 5 || nowMonth == 6) {
        this.disasterTile[6] = "注意梅雨";
      }
    },
  },
};
</script>

<style scoped>
.gis-info {
  height: auto;
  display: inline-block !important;
}
.pointer:hover {
  cursor: pointer;
}
.gis-basic .gis-info {
  overflow-y: auto;
  overflow-x: hidden;
}

.title {
  background-color: #4f8321;
  color: white;
}
.text-green {
  color: #4f8321;
}
div.tab-pane {
  border: 1px solid #4f8321 !important;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  padding: 10px !important;
}
.hidescroll {
  overflow-y: hidden;
}
</style>
